'use strict';

ColumnDefinitionService.$inject = ['$q', 'mx.SolutionBuilderAgent.Http', 'mx.sb.Agent.DataQuery.DataQueryDefinition'];
export default function ColumnDefinitionService($q, http, DataQueryDefinition) {
	var cache = { columns: {}, entityClassColumns: [] };

	return {
		getGridDefinitionById: getGridDefinitionById,
		getGridDefinitionByName: getGridDefinitionByName,
		getGridDefinitionByClassName: getGridDefinitionByClassName,
		initDataQuery: initDataQuery,
		removeFromCache: removeFromCache,
		loadColumnsForClass: loadColumnsForClass,
	};

	function getGridDefinitionByName(name) {
		return _getDefinition(null, name);
	}

	function getGridDefinitionByClassName(className) {
		return _getDefinition(null, null, className);
	}

	function getGridDefinitionById(dataQueryId, widgetId) {
		return _getDefinition(dataQueryId, null, null, widgetId);
	}

	function removeFromCache(dataQueryId) {
		_.forOwn(cache.columns, function (val, key) {
			if (val.Id === dataQueryId) {
				cache.columns[key] = null;
			}
		});
	}

	function _getDefinition(id, name, entityClass, widgetId) {
		var params = {};
		var cacheKey = null;

		if (widgetId) {
			params.widgetId = widgetId;
			params.id = id;
			cacheKey = 'widgetId_' + widgetId.toLowerCase() + '_' + 'id_' + id.toLowerCase();
		} else {
			if (id) {
				params.id = id;
				cacheKey = 'id_' + id.toLowerCase();
			} else if (name) {
				params.name = name;
				cacheKey = 'name_' + name.toLowerCase();
			} else if (entityClass) {
				params.entityClass = entityClass;
				cacheKey = 'class_' + entityClass.toLowerCase();
			}
		}

		var promise;
		if (!cache.columns[cacheKey]) {
			promise = http.get('api/DataQuery/columns', params, {}, true).then(function (dataQueryDef) {
				if (dataQueryDef.IsDefault && dataQueryDef.SchemaClassName) {
					cache.columns['class_' + dataQueryDef.SchemaClassName.toLowerCase()] = dataQueryDef;
				}
				cache.columns['name_' + dataQueryDef.Name.toLowerCase()] = dataQueryDef;
				cache.columns['id_' + dataQueryDef.Id.toLowerCase()] = dataQueryDef;

				if (widgetId) {
					cache.columns['widgetId_' + widgetId.toLowerCase() + '_' + 'id_' + dataQueryDef.Id.toLowerCase()] = dataQueryDef;
				}

				return dataQueryDef;
			});
		} else {
			promise = $q.when(cache.columns[cacheKey]);
		}

		return promise.then(initDataQuery);
	}

	function initDataQuery(dataQueryDef) {
		return new DataQueryDefinition(dataQueryDef);
	}

	function loadColumnsForClass(className) {
		if (!cache.entityClassColumns[className]) {
			cache.entityClassColumns[className] = http.get('api/DataQuery/LoadColumns', { SchemaClassName: className });
		}

		return cache.entityClassColumns[className];
	}
}
